import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
    const navigate = useNavigate();

    return (
        <div className="privacy-container">
            <div className="privacy-header">
                <h1>プライバシーポリシー</h1>
            </div>
            <div className="privacy-content">
                <section>
                    <h2>1. 収集する情報</h2>
                    <p>
                        本サービス（FlowText）では、サービスの提供にあたり、以下の情報を収集・利用することがあります。
                    </p>
                    <ul>
                        <li><strong>アカウント情報：</strong> 認証プロバイダ（Google等）を通じて提供されるメールアドレス、ユーザーID。</li>
                        <li><strong>生成データ：</strong> ユーザーが作成したフローチャートデータ、入力したテキスト。</li>
                        <li><strong>利用ログ：</strong> アクセス日時、IPアドレス、ブラウザ情報などのアクセスログ。</li>
                    </ul>
                </section>

                <section>
                    <h2>2. 重用な注意事項</h2>
                    <p>
                        <strong>個人情報の入力禁止：</strong> AIによる生成のために入力されるテキストやフローチャート内に、個人を特定できる情報（氏名、住所、電話番号など）や機密情報を入力しないでください。
                    </p>
                </section>

                <section>
                    <h2>3. 情報の利用目的</h2>
                    <p>収集した情報は、以下の目的で利用します。</p>
                    <ul>
                        <li>本サービスの提供・運営のため</li>
                        <li>ユーザーへのお知らせや問い合わせ対応のため</li>
                        <li>利用規約に違反する行為の監視・対応のため</li>
                        <li>サービスの改善・新機能開発のため</li>
                    </ul>
                </section>

                <section>
                    <h2>4. 第三者への提供（AIプロバイダ）</h2>
                    <p>
                        本サービスは、テキスト生成およびモデレーション機能を提供するために、<strong>OpenAI API</strong>を利用しています。
                        ユーザーが入力したテキストデータは、処理のためにOpenAI社に送信されます。
                    </p>
                    <ul>
                        <li>送信されたデータは、OpenAI社のプライバシーポリシーに従って取り扱われます。</li>
                        <li>OpenAI社によるデータの学習利用については、当該社の規約をご確認ください（API利用の場合、通常は学習に利用されませんが、規約は変更される可能性があります）。</li>
                    </ul>
                </section>

                <section>
                    <h2>5. データの保存と管理</h2>
                    <p>
                        ユーザーのフローチャートデータは、Firebase（Google Cloud）上のデータベースに安全に保存されます。
                        適切なセキュリティ対策を講じ、不正アクセスや漏洩の防止に努めます。
                    </p>
                </section>

                <section>
                    <h2>6. ユーザーの権利</h2>
                    <p>
                        ユーザーは、自身の登録データや作成したチャートデータの削除を求めることができます。
                        アカウント削除機能を使用することで、関連するデータをシステムから削除可能です。
                    </p>
                </section>

                <section>
                    <h2>7. プライバシーポリシーの変更</h2>
                    <p>
                        本ポリシーの内容は、法令その他別段の定めのある事項を除いて、ユーザーに通知することなく変更することができるものとします。
                        変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。
                    </p>
                </section>

                <div className="privacy-actions">
                    <button onClick={() => navigate('/')} className="back-button">
                        トップページに戻る
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
